const collections = [
  { title: '明星恋情追踪', desc: '最新明星恋情动态与实锤盘点', count: 38, tag: '热追' },
  { title: '综艺名场面精选', desc: '热门综艺争议片段与高光时刻', count: 56, tag: '热议' },
  { title: '网红翻车实录', desc: '网红主播争议事件与反转合集', count: 24, tag: '爆款' },
  { title: '影视剧内幕揭秘', desc: '热门影视作品幕后故事与删减内容', count: 42, tag: '独家' },
  { title: '品牌代言风波', desc: '明星代言更换与品牌合作内幕', count: 19, tag: '新' },
  { title: '音乐圈热点速递', desc: '音乐节、演唱会与歌手最新动态', count: 31, tag: '热' },
  { title: '直播带货观察', desc: '头部主播最新争议与行业动态', count: 27, tag: '追踪' },
  { title: '时尚造型点评', desc: '明星红毯造型与日常穿搭热议', count: 45, tag: '精' },
  { title: '社会热议深扒', desc: '引发全网讨论的社会热点事件', count: 63, tag: '深度' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">专题合集</h2>
          <span className="text-xs text-foreground-400">{collections.length} 个精选专题</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {collections.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group flex items-start gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-folder-chart-line text-accent-600 text-xl"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-accent-700 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="text-[10px] font-medium bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.count} 条内容</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}